import cls from "classnames";
import FieldWrapper from "./FieldWrapper";

export default function NameField({
  label,
  type,
  name,
  placeholder,
  onChange,
  disabled,
  formatValue,
  validator,
  required,
  hint,
  error,
  value,
  options,
  visible,
  className,
}) {
  return (
    <FieldWrapper error={error} hint={hint} visible={visible}>
      {label && (
        <label htmlFor="input" className="font-semibold text-sm">
          {label}
        </label>
      )}

      <input
        name={name}
        placeholder={placeholder}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e, { formatValue, validator, required })}
        disabled={disabled}
        className={cls(
          className
            ? className
            : "border-[1px] border-[#D5D8DC] p-2 outline-none w-full max-w-[420px] rounded-[4px] h-auto",
          label ? "mt-0" : "-mt-3",
          disabled ? "cursor-not-allowed" : ""
        )}
      />
    </FieldWrapper>
  );
}
